export default "__VITE_ASSET__BXPvF_Bt__"